module.exports = global["React"] = require("-!/home/vvo/Dev/Algolia/instantsearch.js/node_modules/react/react.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/react/react.js
 ** module id = 220
 ** module chunks = 0
 **/